import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { WebSocketManager, ConnectionState } from './websocket-manager.service';

@Component({
  selector: 'app-connection-status',
  template: `
    <div class="connection-status" [ngClass]="getStatusClass()">
      <i class="pi" [ngClass]="getIconClass()"></i>
      <span *ngIf="showLabel">{{ getStatusText() }}</span>
    </div>
  `,
  styles: [`
    .connection-status {
      display: flex;
      align-items: center;
      gap: 4px;
      padding: 2px 6px;
      border-radius: 4px;
      font-size: 12px;
      transition: all 0.3s ease;
    }
    .connected { color: #22c55e; }
    .connecting, .reconnecting { color: #f59e0b; }
    .disconnected, .failed { color: #ef4444; }
  `]
})
export class ConnectionStatusComponent implements OnInit, OnDestroy {
  connectionState: ConnectionState = ConnectionState.DISCONNECTED;
  showLabel = false;
  private destroy$ = new Subject<void>();

  constructor(private wsManager: WebSocketManager) {}

  ngOnInit(): void {
    this.wsManager.connectionState$
      .pipe(takeUntil(this.destroy$))
      .subscribe(state => {
        this.connectionState = state;
        this.showLabel = state !== ConnectionState.CONNECTED;
        
        // Auto-hide label after connection is restored
        if (state === ConnectionState.CONNECTED && this.showLabel) {
          setTimeout(() => this.showLabel = false, 3000);
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getStatusClass(): string {
    return this.connectionState;
  }

  getIconClass(): string {
    switch (this.connectionState) {
      case ConnectionState.CONNECTED: return 'pi-check-circle';
      case ConnectionState.CONNECTING: 
      case ConnectionState.RECONNECTING: return 'pi-spin pi-spinner';
      default: return 'pi-exclamation-triangle';
    }
  }

  getStatusText(): string {
    switch (this.connectionState) {
      case ConnectionState.CONNECTING: return 'Connecting...';
      case ConnectionState.RECONNECTING: return 'Reconnecting...';
      case ConnectionState.DISCONNECTED: return 'Offline';
      case ConnectionState.FAILED: return 'Connection failed';
      default: return '';
    }
  }
}